import { Point2D } from '../../team-apis/otterdam/answers/shape-typings';
import { RendererLayer } from '../render/render-utils';
import { Axis } from '../renderers/side-view/side-view.component';

export const mainViewRegionName = 'mainView';
export const sideViewRegionName = 'sideView';
export const backViewRegionName = 'backView';
export const topViewRegionName = 'topView';
export const orthographicViewRegionName = 'orthographicView';

export interface ViewRegion {
  layer: RendererLayer;
  lowerLeftCorner: Point2D;
  outputName: string;
  size: Point2D;
}

export class ViewRegionState {
  regions: StrictRecord<string, ViewRegion>;
  isMainViewInThumbnailMode = false;
  hasEditPanelsOpen = false;

  constructor() {
    const sharedDefaultProperties = {
      lowerLeftCorner: [0, 0] as Point2D,
      outputName: '',
      size: [0, 0] as Point2D,
    };

    this.regions = {
      [mainViewRegionName]: {
        layer: RendererLayer.Main,
        ...sharedDefaultProperties,
      },
      [sideViewRegionName]: {
        layer: RendererLayer.SideViewBottom,
        ...sharedDefaultProperties,
      },
      [backViewRegionName]: {
        layer: RendererLayer.SideViewMiddle,
        ...sharedDefaultProperties,
      },
      [topViewRegionName]: {
        layer: RendererLayer.SideViewTop,
        ...sharedDefaultProperties,
      },
      [orthographicViewRegionName]: {
        layer: RendererLayer.Orthographic,
        ...sharedDefaultProperties,
      },
    };
  }
}

// eslint-disable-next-line complexity -- Ok for shallow switch
export function getViewRegionNameForLayer(layer: RendererLayer) {
  switch (layer) {
    case RendererLayer.Main:
      return mainViewRegionName;
    case RendererLayer.SideViewTop:
      return topViewRegionName;
    case RendererLayer.SideViewMiddle:
      return backViewRegionName;
    case RendererLayer.SideViewBottom:
      return sideViewRegionName;
    case RendererLayer.Orthographic:
      return orthographicViewRegionName;
    default:
      throw new Error('Invalid layer');
  }
}

export function getViewRegionNameForAxis(axis: Axis) {
  switch (axis) {
    case 0:
      return sideViewRegionName;
    case 1:
      return backViewRegionName;
    case 2:
      return topViewRegionName;
    default:
      throw new Error('Invalid axis');
  }
}
